
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/disease-encyclopedia/select-subject",
      function () {
        return require("private-next-pages/disease-encyclopedia/select-subject/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/disease-encyclopedia/select-subject"])
      });
    }
  